import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Label,
  Table,
} from 'reactstrap';
import $ from 'jquery';
import QuestionPage from '../views/QuestionPage/';
import Sanitize from '../Sanitize';
import CKEditor from 'ckeditor4-react';
const GLOBAL = require('../Globals');

class DemoExam extends Component {
	 
	/** set property value **/
	constructor(props){
		super(props);
		MathJax.Hub.Config({
            tex2jax: {
                inlineMath: [['$', '$'], ['\\(', '\\)']],
                displayMath: [['$$', '$$'], ['\\[', '\\]']],
                jax: ["input/TeX", "input/MathML", "input/AsciiMath", "output/HTML-CSS", "output/NativeMML", "output/PreviewHTML"],
            },
            "HTML-CSS": {
                webFont: "TeX",
                automatic: false,
                matchFontHeight: true,
            },
            showMathMenu: false,
        });
		this.state = {
			acyear : '',
			accyear : [],
			_message : '',
			alertClass :'',
			posts : [],
			imgdata : [],
			result : [],
			_redirect : false,
			isview : false,
			regno : ''
		}
		this.onacChange = this.onacChange.bind(this);
		this.onViewClick = this.onViewClick.bind(this);
		this.onChange=this.onChange.bind(this);
		this.onSubmit=this.onSubmit.bind(this);
	}
	
	onRadioChange(id,value,e){
		var d = this.state.result;

		var index = d.findIndex(function(obj){
			return(obj.id == id);
		});

		var index1 = this.state.posts.findIndex(function(obj){
			return(obj.questionid == id);
		});
		var status = 0;
		if(this.state.posts[index1].answer == value){
			status = 1;
		}

		if(index > -1){
			d[index].value = value;
			d[index].status = status;
		}
		else{
			d.push({"id" : id,"value" : value,"status" : status});
		}
		this.setState({result : d});
	}

	onChange(e){
		this.setState({
			posts : [],
			imgdata : [],
			isview : false
		})
		this.setState({[e.target.name] : e.target.value});		
	}

	onViewClick(e){
		this.getexam();
	}
	
	onacChange(e){
		this.setState({[e.target.name]:e.target.value,data : []});
	}

	/** submit form **/
	onSubmit(e){
		$("#showLoader").show();
		PostData('question/saveresult',this.state).then((result) => {
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'Save Successfully!..',
					alertClass:'alert alert-success',
					btnText : 'Save',
					posts : [],
					imgdata : [],
					regno : '',
					isview : false
				});
				$("#regno").val('');
			}
			else{
		
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
			$("#showLoader").hide();
		});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
		MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    }

    componentDidUpdate() {
        $("span.math-tex").closest("p").css("display", "inline");
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
			}
		});
	}

	getexam(){
		$("#showLoader").show();
		GetData('question/getexambyregno/'+this.state.acyear+'/'+this.state.regno).then((result) => {
			let responseJson = result;
			if(responseJson.status ==1){
				this.setState({
					posts : responseJson.data,
					examname : responseJson.data[0]['examname'],
					subname : responseJson.data[0]['subname'],
					examdate : responseJson.data[0]['examdate'],
					fromtime : responseJson.data[0]['fromtime'],
					totime : responseJson.data[0]['totime'],
					timelimit : responseJson.data[0]['timelimit'],
					totalmarks : responseJson.data[0]['totalmarks'],
					cls : responseJson.data[0].class,
					sec : responseJson.data[0].section,
					exam : responseJson.data[0].id,
					subject : responseJson.data[0].subject,
					noofmarks : responseJson.data[0].noofmarks,
					imgdata : responseJson.img,
					isview : true
				});
			}
			else{
				alert('No Exam');
			}
			$("#showLoader").hide();
		});
	}

	getImageQuestion(id){
		var d = this.state.imgdata;
		var image = [];
		for(var i=0;i<d.length;i++){
			if(d[i].question == id){
				image.push(<img src={GLOBAL.BASE_URL+d[i].image} />);
			}
		}
		return image;
	}
	
  render() {
	
	var acyear = this.state.accyear;
	let userData = JSON.parse(sessionStorage.getItem('userData'));
	this.state.userId = userData['userid'];
	
    return (
		<div>
		  <QuestionPage />
			<div className="animated fadeIn" style={{marginTop : '45px'}}>
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card >
						<CardHeader style={{position: 'fixed',width: '80.6%',zIndex: '9',backgroundColor : '#20a8d8',color : '#FFF'}}>
							<strong>Demo Exam</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<select name="acyear" onChange={this.onacChange} required id="year">
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							</select>&emsp;
							<input type="text" name="regno" id="regno" onChange={this.onChange} placeholder="Student Regno" required />&emsp;
							<Button color="warning" onClick={this.onViewClick}>View</Button>
							{this.state.isview ? 
							<span style={{float : 'right',fontSize : '18px'}}>No of questions : <b>{this.state.posts.length}</b>&emsp;Answered questions : <b>{this.state.result.length}</b></span> : ''}
						</CardHeader>
						<CardBody>
							{this.state.isview ?
							<Row style={{marginTop : '20px'}}>
								<Col md="12" style={{marginTop : '25px'}}>
									<table width="100%">
										<tbody>
											<tr>
												<td align="center" colSpan="2"><b style={{fontSize : '20px'}}>{this.state.examname}</b></td>
											</tr>
											<tr>
												<td align="center" colSpan="2"><b style={{fontSize : '16px'}}>{this.state.subname}</b></td>
											</tr>											
											<tr>
												<td>Date : <b>{Sanitize.dmyDash(this.state.examdate)}</b><br />Time : <b>{this.state.fromtime.slice(0, 5)} to {this.state.totime}</b></td>
												<td align="right">Hours : <b>{this.state.timelimit}</b><br />Total Marks : <b>{parseFloat(this.state.totalmarks)}</b></td>
											</tr>
										</tbody>
									</table>
								</Col>
								<Col md={12} style={{marginTop : '15px'}}>
									<Table responsive>
										<tbody>
											{this.state.posts.map((item,i)=>
												<React.Fragment>
													<tr>
														<td colSpan="4" style={{border : '0px'}} align="left">
															<FormGroup check inline>
																{i+1}.&emsp;<div dangerouslySetInnerHTML={{ __html: item.qusname }}></div>
																{this.getImageQuestion(item.questionid)}
															</FormGroup>
														</td>
													</tr>
													<tr>
														<td style={{border : '0px',paddingBottom : '10px'}}>
															&emsp;&emsp;<FormGroup check inline>
																a)&nbsp;<input type="radio" name={"radios" + i} id="inline-radio" onChange={this.onRadioChange.bind(this,item.questionid,'option1')} />&emsp;
																<Label className="form-check-label" check htmlFor="inline-radio"><div dangerouslySetInnerHTML={{ __html: item.option1 }}></div>
																{item.optimage1!='' && item.optimage1!=null ? <img src={GLOBAL.BASE_URL+item.optimage1} /> : ''}
																</Label>
															</FormGroup>
														</td>
														<td style={{border : '0px',paddingBottom : '10px'}}>
															&emsp;&emsp;<FormGroup check inline>
																b)&nbsp;<input type="radio" name={"radios" + i} id="inline-radio" onChange={this.onRadioChange.bind(this,item.questionid,'option2')} />&emsp;
																<Label className="form-check-label" check htmlFor="inline-radio"><div dangerouslySetInnerHTML={{ __html: item.option2 }}></div>
																{item.optimage2!='' && item.optimage2!=null ? <img src={GLOBAL.BASE_URL+item.optimage2} /> : ''}
																</Label>
															</FormGroup>
														</td>
														<td style={{border : '0px',paddingBottom : '10px'}}>
															&emsp;&emsp;<FormGroup check inline>
																c)&nbsp;<input type="radio" name={"radios" + i} id="inline-radio" onChange={this.onRadioChange.bind(this,item.questionid,'option3')} />&emsp;
																<Label className="form-check-label" check htmlFor="inline-radio"><div dangerouslySetInnerHTML={{ __html: item.option3 }}></div>
																{item.optimage3!='' && item.optimage3!=null ? <img src={GLOBAL.BASE_URL+item.optimage3} /> : ''}
																</Label>
															</FormGroup>
														</td>
														<td style={{border : '0px',paddingBottom : '10px'}}>
															&emsp;&emsp;<FormGroup check inline>
																d)&nbsp;<input type="radio" name={"radios" + i} id="inline-radio" onChange={this.onRadioChange.bind(this,item.questionid,'option4')} />&emsp;
																<Label className="form-check-label" check htmlFor="inline-radio"><div dangerouslySetInnerHTML={{ __html: item.option4 }}></div>
																{item.optimage4!='' && item.optimage4!=null ? <img src={GLOBAL.BASE_URL+item.optimage4} /> : ''}
																</Label>
															</FormGroup>
														</td>
													</tr>
												</React.Fragment>
											)}
										</tbody>
									</Table>
								</Col>
								<Col md="12">
									<Button color="success" onClick={this.onSubmit} style={{float : 'right'}} disabled={this.state.result.length > 0 ? false : true}>Save</Button>
								</Col>
							</Row> : ''}
						</CardBody>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default DemoExam;


// WEBPACK FOOTER //
// ./src/Questions/DemoExam.js